export enum PLRoutes {
	HOME = 'payment-links-3',
	SALES = 'sales',
	ALL = 'all',
	LINKS = 'links',
}
